import {useContext, useEffect, useState} from "react";
import {LoadingContext, PageContext, ToastContext, UserContext} from "../../contexts";
import {Arquivo, Paginacao} from "../../components";
import {NotificacaoApi, PublicacaoApi} from "../../apis";
import {FaBell, FaKey, FaNewspaper, FaUsers} from "react-icons/fa";
import NoPic from "../../assets/img/no-pic.jpg";
import {useLocation, useNavigate} from "react-router";

export const Inicio = () => {
  const {user} = useContext(UserContext);
  const {pageInfo, setPageInfo} = useContext(PageContext);
  const [carregado, setCarregado] = useState(false);
  const [publicacoes, setPublicacoes] = useState(null);
  const [pagina, setPagina] = useState(1);
  const [paginacaoInfo, setPaginacaoInfo] = useState(null);
  const {setLoading} = useContext(LoadingContext);
  const navigate = useNavigate();
  const [qtdNotificacao, setQtdNotificacao] = useState(0);
  const location = useLocation();

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const loadPublicacoes = async () => {
    setLoading(true);
    let search = null;
    let respostaPublicacao;
    try {
      if (typeof location.state.search !== 'undefined') {
        search = (location.state.search);
      }
    } catch (e) {}
    try {
      if (search !== null) {
        respostaPublicacao = await PublicacaoApi.getAllSearch(user.uuid, pagina, search);
      } else {
        respostaPublicacao = await PublicacaoApi.getAll(user.uuid, pagina);
      }

      if (!respostaPublicacao.error) {
        let tempArq = [];
        let PublicacaoManual = await PublicacaoApi.getManual();
        if(PublicacaoManual.data){
          tempArq.push(PublicacaoManual.data.publicacao);
        }
        
        for (let i = 0; i < respostaPublicacao.data.length; i++) {
          tempArq.push(respostaPublicacao.data[i]);
        }
        setPublicacoes(tempArq);
        setPaginacaoInfo(respostaPublicacao.paginacao);
        setLoading(false);
      } else {
        setLoading(false);
        AddToast({texto: respostaPublicacao.error, tipo: "erro"});
      }
    } catch (e) {
      setLoading(false);
      AddToast({texto: e, tipo: "erro"});
    }
  }

  useEffect(() => {
    loadPublicacoes()
  }, [pagina]);

  const loadQtdNotificacao = async () => {
    try {
      let respostaNotificacao = await NotificacaoApi.getQtd(user.uuid);
      if (!respostaNotificacao.error) {
        setQtdNotificacao(respostaNotificacao.data);
      }
    } catch (e) {

    }
  }

  if (!carregado) {
    loadPublicacoes();
    loadQtdNotificacao();
    setPageInfo(
      {
        ...pageInfo,
        titulo: 'Publicações',
        icone: <FaNewspaper size={30}/>
      }
    );
    setCarregado(true);
  }

  return (
    <div className="painel">
      <div className="caixas">
        <div className="parte-um">
          <div className="caixa caixa-publicacoes">
            <FaNewspaper size={100}/>
            <div className="info">
              <span className="texto">Publicações</span>
              {paginacaoInfo && <span className="numero">{paginacaoInfo.total_registros}</span>}
            </div>
          </div>
          <div className="caixa caixa-ci">
            <FaBell size={70}/>
            <div className="info">
              <span className="texto">Notificações</span>
              <span className="numero">{qtdNotificacao}</span>
            </div>
          </div>
        </div>
        <div className="caixa-user">
          <div className="avatar-100">
            <img src={user.avatar ? user.avatar : NoPic} alt="avatar"/>
          </div>
          <div className="user-info">
            <span className="nome">Olá, {user.nome}</span>
            <span className="funcao">Função: {user.funcao}</span>
            <div className="botoes">
              <div className="btn btn-secondary" onClick={() => {
                navigate('/portalcolaborador/user/edit', {state: {uuid: user.uuid}})
              }}>
                <FaUsers/>
                Editar perfil
              </div>
              <div className="btn btn-secondary" onClick={() => {
                navigate('/portalcolaborador/user/senha', {state: {uuid: user.uuid}})
              }}>
                <FaKey/>
                Alterar senha
              </div>
            </div>
          </div>
        </div>
      </div>

      {publicacoes ?
        <div className="painel-itens">
          <div className="cabecalho">
            <FaNewspaper size={30}/>
            <span>Publicações mais recentes.</span>
          </div>
          {publicacoes.map((item, index) =>
            <Arquivo item={item} key={index} update={loadPublicacoes}/>
          )}
          <Paginacao pagina={pagina} setPagina={setPagina} info={paginacaoInfo}/>
        </div>
        :
        <h3>Ops... Ainda não há publicações para serem exibidas</h3>
      }
    </div>
  )
}